import React, { useState, useEffect, useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import 'react-rater/lib/react-rater.css';
import styled, { css } from 'styled-components';
import AnimatedRater from '../Global/AnimatedRater.jsx';
import ButtonInput from './ButtonInput.jsx';
import { OptionContext } from '../../contexts/OptionContext.jsx';

const ColCustom = styled(Col)`
  ${(props) => css`
    color: ${props.foreground}
  `}
`;

const RaterInput = ({ options = [], next }) => {
  const [state, setState] = useState({
    value: [],
  });

  const context = useContext(OptionContext);
  const { header, input, dialog } = context;

  useEffect(() => {
    setState({
      ...state,
      value: options.map((rater) => ({ ...rater, value: 3 })),
    });
  }, []);

  const setRating = (key, value) => {
    const newValue = state.value.map((rate) => (rate.key === key ? { ...rate, value } : { ...rate }));
    setState({
      ...state,
      value: newValue,
    });
  };

  return (
    <Container>
      <Row className="justify-content-md-start justify-content-center">
        <Col xs="auto" className="ml-0 ml-md-7 mt-4">
          {
            state.value.map((rater) => (
              <Row className="my-2" key={rater.key}>
                <ColCustom foreground={dialog.foreground}>
                  {rater.text}
                </ColCustom>
                <Col xs="auto">
                  <AnimatedRater
                    onChange={(value) => setRating(rater.key, value)}
                    value={rater.value}
                    activeColor={header.background}
                    willBeActiveColor={input.rating.willBeActive}
                  />
                </Col>
              </Row>
            ))
          }
        </Col>

        <ButtonInput buttons={[{
          text: 'Continuar',
          onClick: () => {
            next(state.value);
          },
        }]}
        />
      </Row>
    </Container>

  );
};

export default RaterInput;
